module.exports = __webpack_public_path__ + "assets/feedbackicon-1.27d4004d.svg";